import React from 'react';
import { LongTermGoalDescriptionScreen, Theme } from 'fitbeat.react-native-components';
import { AccountType } from 'fitbeat.models';
import { HomeCarouselAuthLayout } from './Layouts/HomeCarouselAuthLayout';

export const LongTermGoalDescriptionContainer = (props) => (
  <HomeCarouselAuthLayout header={''} {...props} accountType={AccountType.Studio}>
    <LongTermGoalDescriptionScreen {...props} />
  </HomeCarouselAuthLayout>
);
